import { render } from "./page-search.vue?vue&type=template&id=6e85cdae&scoped=true&ts=true"
import script from "./page-search.vue?vue&type=script&lang=ts"
export * from "./page-search.vue?vue&type=script&lang=ts"

import "./page-search.vue?vue&type=style&index=0&id=6e85cdae&lang=less&scoped=true"

import exportComponent from "E:\\项目对接\\parent-reporting-backend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e85cdae"]])

export default __exports__